
import filter from 'lodash/filter';

export class AuthService {
	constructor($resource, ApiService, $cookies, $state, $window) {
		'ngInject';

		this.$resource = $resource;
		// this.$http = $http;
		this.apiService = ApiService;
		const loginUrl = this.apiService.getResourceUrl('login');
		const logoutUrl = this.apiService.getResourceUrl('logout');
		this.forgotPasswordResourceUrl = this.apiService.getResourceUrl('forgot-password');
		this.resetPasswordResourceUrl = this.apiService.getResourceUrl('password/reset/:token');
		const updatePasswordResourceUrl = this.apiService.getResourceUrl('password/change');
		this.loginState = false;
		this.$cookies = $cookies;
		this.$window = $window;
		this.authData = {};
		this.$state = $state;

        this.updatePasswordResource = this.$resource(updatePasswordResourceUrl, null, {
            update: {
                method: 'put'
            }
        });
		this.loginResource = this.$resource(loginUrl, null, {
			add: {
				method: 'post'
			}
		});
		this.logoutResource = this.$resource(logoutUrl, null, {
			add: {
				method: 'put'
			}
		});

		this.forgotPasswordResource = this.$resource(this.forgotPasswordResourceUrl, null, {
			save: {
				method: 'POST'
			}
		});
		this.resetPasswordResource = this.$resource(this.resetPasswordResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.loginRedirectRoute = '';
	}

	/*
	* @method getProduct
	* @returns 
	*/
	getProduct() {
		return this.product;
	}

	isAuthenticated() {
		const session = this.$cookies.getObject('user');
		if (session) {
			this.authData = session;
			return true;
		} else {
			return false;
		}
		return false;
	}
	
	getAuthorizationHeader(){
		var token = this.$cookies.get('token');
		var authHeader = '';
		if (token) {
			authHeader = 'JWT ' + token;
		} 
		return authHeader;
	}

	setHeader() {
		this.apiService.removeDefaultHeaders();
		var authHeader = this.getAuthorizationHeader();
		this.apiService.setDefaultHeaders(authHeader);
	}

	login(username, password) {
		const promise = this.loginResource.add({
			email: username,
			password: password
		}).$promise;

		return new Promise((resolve, reject) => {
			promise.then((result) => {
				this.setUser(result.data.user);
				this.$cookies.put('token', result.data.token);
				resolve();
			}, reject);
		});
	}

	setLoginRedirect(_state) {
		this.loginRedirectRoute = _state;
	}

	getLoginRedirect() {
		return this.loginRedirectRoute;
	}

	removeCookies() {
		this.loginState = false;
		this.$cookies.remove('user');
		this.$cookies.remove('token');
		this.$cookies.remove('menuList');
//		this.setHeader();
	}

	expireSession() {
		this.removeCookies();
		this.$state.go('app.login');
	}

	logout() {
		const promise = this.logoutResource.add().$promise;
		return new Promise((resolve, reject) => {
			promise.then((result) => {
				this.expireSession();
				resolve();
			}, reject);
		});
	}

	setUser(data) {
		this.authData = data;
		this.authData.name = `${ this.authData.first_name } ${ this.authData.last_name }`; //to do this.authData.name
		this.authData.image = this.authData.image ? this.apiService.getImageUrl(this.authData.image) : '';
		this.$cookies.putObject('user', this.authData);
	}

	getUser() {
		return this.$cookies.getObject('user');
	}

	
	getUserRole() {
		return {
			role: this.authData.role,
			isAdmin: (this.authData.role && this.authData.role.indexOf('Admin') > 0) ? true : false
		}
	}

	_setEmailIdObj(value) {
		return {
			email: value
		}
	}
	

	setPasswordObject(value) {
        return {
            old_password: value.currentPassword,
			new_password: value.newPassword,
			re_type_password:value.reTypePassword
        }
    }

	_setPasswordObj(value) {
		return {
			new_password: value.newPassword,
			re_type_password: value.confirmPassword
		};
	}

	forgotPassword(data) {
		const promise = this.forgotPasswordResource.save(this._setEmailIdObj(data)).$promise;

		return promise.then((emailDetails) => {
			return emailDetails.data;
		}).catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}

	confirmToken(token) {
		const promise = this.resetPasswordResource.get({
			token: token
		}).$promise;

		return promise.then((confirmDetails) => {
			return confirmDetails.data;
		}).catch((error) => {
			throw error;
		});
	}

    updatePassword(details) {
        const promise = this.updatePasswordResource.update(this.setPasswordObject(details)).$promise;

		return promise.then((details) => {
	      	return details.data;
	    }).catch(({data}) => {
	      	throw data;
	    });
    }

	resetPassword(token, details) {
		const promise = this.resetPasswordResource.update({ token: token }, this._setPasswordObj(details)).$promise;
		return promise.then((resetDetails) => {
			return resetDetails.data;
		}).catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}
};



// WEBPACK FOOTER //
// ./src/app/components/auth/auth.service.js